import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  GROUPS_PROGRESS,
  GROUPS_SUCCESS,
  GROUPS_FAILED,
  GROUPS_GET_LIST_PROGRESS,
  GROUPS_GET_LIST_SUCCESS,
  GROUPS_GET_LIST_FAILED,
  GROUPS_FORM_SUBMIT_PROGRESS,
  GROUPS_FORM_SUBMIT_SUCCESS,
  GROUPS_FORM_SUBMIT_FAILED,
  GROUPS_GET_GROUP_PROGRESS,
  GROUPS_GET_GROUP_SUCCESS,
  GROUPS_GET_GROUP_FAILED,
  GROUPS_GET_ASYNC_DATA_PROGRESS,
  GROUPS_GET_ASYNC_DATA_SUCCESS,
  GROUPS_GET_ASYNC_DATA_FAILED,
  GROUPS_DELETE,
  GROUPS_CLEAR_STATE,
  GROUPS_CLEAR_FLASH_MESSAGE,
} from '../actions/groupsAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  isDelete: false,
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GROUPS_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: GROUPS_PROGRESS },
      });
    }
    case GROUPS_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: GROUPS_SUCCESS },
      });
    }
    case GROUPS_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: GROUPS_FAILED },
      });
    }
    case GROUPS_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: GROUPS_PROGRESS } });
    }
    case GROUPS_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: GROUPS_SUCCESS },
      });
    }
    case GROUPS_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: GROUPS_FAILED } });
    }
    case GROUPS_GET_GROUP_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: GROUPS_PROGRESS },
      });
    }
    case GROUPS_GET_GROUP_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.group },
        loadActiveStatus: { $set: GROUPS_SUCCESS },
      });
    }
    case GROUPS_GET_GROUP_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: GROUPS_FAILED },
      });
    }
    case GROUPS_GET_ASYNC_DATA_PROGRESS: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: GROUPS_PROGRESS },
      });
    }
    case GROUPS_GET_ASYNC_DATA_SUCCESS: {
      return update(state, {
        asyncData: { $set: action.payload },
        asyncStatus: { $set: GROUPS_SUCCESS },
      });
    }
    case GROUPS_GET_ASYNC_DATA_FAILED: {
      return update(state, {
        asyncData: { $set: {} },
        asyncStatus: { $set: GROUPS_FAILED },
      });
    }
    case GROUPS_DELETE: {
      return update(state, {
        isDelete: { $set: true },
      });
    }
    case GROUPS_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        isDelete: { $set: false },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case GROUPS_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
